const segmentNormalizeConstant = {
  DESPACHANTE: 2,
  VEICULOS: 3,
  GERAL: 4,
  CEMITERIO: 15,
  EDUCACAO: 9,
  PATIO: 10,
  ACESSORIA: 11,
  BOLETO: 5,
  DETRAN: 7,
  CREA: 8,
  FINANCIAMENTO: 12,
  RECHARGE: 13,
  TOTEM: 14,
  CARTORIO: 16,
  COOPNORE: 17,
  MONITORING: 19,
  LINK_VAREJO: 21,
  GERENCIAR_BOLETOS: 23,
};

export const segmentNormalizeInvertConstant = Object.keys(
  segmentNormalizeConstant
).reduce((acc, key) => {
  return {
    ...acc,
    [segmentNormalizeConstant[key]]: key,
  };
}, {});

export default segmentNormalizeConstant;
